import React, { ReactNode, createContext, useContext } from "react";
import { MonthStar } from "../../model/accounting/date/MonthStar.js";
import { useFilter } from "./FilterProvider.js";

type PeriodState = {
  year: string;
  month: MonthStar;
  titleSearch: string;
};

const PeriodContext = createContext<PeriodState | undefined>(undefined);

/**
 * Provides reporting period from filter selection.
 */
export const FilterPeriodProvider = ({ children }: { children: ReactNode }) => {
  const { year, month, titleSearch } = useFilter();
  const value: PeriodState = { year, month, titleSearch };
  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>;
};

/**
 * Provides static reporting period.
 */
export const StaticPeriodProvider = ({
  children,
  year,
  month,
  titleSearch
}: { children: ReactNode } & PeriodState) => {
  const value: PeriodState = { year, month, titleSearch };
  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>;
};

/**
 * Helper hook to use the period context.
 */
export const usePeriod = () => {
  const context = useContext(PeriodContext);
  if (!context) {
    throw new Error("Period context is not provided.");
  }
  return context;
};
